export default function generateRequestId(): string {
  return (
    new Date().toISOString() + Math.floor(Math.random() * 1000000).toString()
  );
}
